// アライアンスチャット添付ファイルの共通定数・ユーティリティ
// バックエンド Alliance::ChatMessage のバリデーションと値を揃える

export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;
export const MAX_ATTACHMENTS_COUNT = 5;
export const ATTACHMENT_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.heic';

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function isImageContentType(contentType: string): boolean {
  return contentType.startsWith('image/');
}

// 選択中ファイルと追加ファイルを合算して上限を検証し、受理分とエラーメッセージを返す
export function validateAttachments(
  current: File[],
  incoming: File[]
): { accepted: File[]; error: string | null } {
  const accepted: File[] = [];
  const oversized: string[] = [];

  for (const file of incoming) {
    if (file.size > MAX_ATTACHMENT_SIZE) {
      oversized.push(file.name);
    } else {
      accepted.push(file);
    }
  }

  const errors: string[] = [];
  if (oversized.length > 0) {
    errors.push(`${oversized.join('、')} は ${formatBytes(MAX_ATTACHMENT_SIZE)} を超えています`);
  }

  const remaining = MAX_ATTACHMENTS_COUNT - current.length;
  let allowed = accepted;
  if (accepted.length > remaining) {
    allowed = accepted.slice(0, Math.max(remaining, 0));
    errors.push(`添付は最大${MAX_ATTACHMENTS_COUNT}件までです`);
  }

  return { accepted: allowed, error: errors.length > 0 ? errors.join(' / ') : null };
}
